import { Observable } from 'rxjs';

export class SortTableFilterObj {
  name: string;
  columnProp: string;
  options: Array<string> = [];
  autocompleteOptions: Observable<string[]>;
}

export class SortTableFilteredDataNotFound {
  notFound = false;
  rowDef = ['filteredDataNotFound'];
  colspan: number;
}

export class SortTableAllFilteredData {
  sortTableFilteredObjs: Array<SortTableFilterObj>;
  sortTableData: Array<Object>;
}
